import { CardVariant } from "./CardVariant";
import { ComboBoxOption } from "./Input";

export type DbProductOverview = {
    id: string,
    productId: number,
    name: string,
    released: string,
    imageUrl: string,
    detailsUrl: string,
    productType: ProductType,
    order: number,
    generallyAvailable: boolean
}

export type DbProduct = DbProductOverview & {
    description: string,
    purchaseLinks: PurchaseLink[],
    productsDescription: string,
    products: ProductDetailsProductJson[],
    cardsDescription: string,
    cards: ProductDetailsCardJson[]
}

export function getDefaultDbProduct(): DbProduct {
    return {
        cards: [],
        cardsDescription: "",
        description: "",
        detailsUrl: "",
        generallyAvailable: false,
        id: "",
        productId: 0,
        imageUrl: "",
        name: "",
        order: 0,
        products: [],
        productsDescription: "",
        productType: "Unknown",
        purchaseLinks: [],
        released: ""
    };
}

export const defaultProduct: DbProductOverview = {
    id: "",
    generallyAvailable: false,
    order: 0,
    productId: 0,
    detailsUrl: "",
    imageUrl: "",
    name: "???",
    released: "???",
    productType: "Unknown"
}

export type ProductDictionary = Record<string, DbProductOverview>;

export const productTypes = ["Booster", "Booster Box", "Prerelease Kit", "Organized Play Reward", "Fan Event Gift", "Starter Deck", "Other", "Unknown"] as const;
export type ProductType = typeof productTypes[number];

export type PurchaseLink = {
    vendor: ProductVendor,
    url: string
}

export type ProductDetailsProductJson = {
    productId: number,
    quantity: number
}

export type ProductDetailsProduct = ProductDetailsProductJson & DbProductOverview;

export type ProductDetailsCardJson = {
    variantId: string,
    quantity?: number
}

export type ProductVendor = "TCGplayer" | "SquareEnixStore";

export type ProductDetailsCard = ProductDetailsCardJson & CardVariant;

export function getMissingProductCard(productDetailsCardJson: ProductDetailsCardJson): ProductDetailsCard {
    return {
        altCardNumber: 0,
        altOpus: 0,
        altSerial: "",
        altRarity: undefined,
        artists: [],
        card: {
            categories: [],
            cost: 0,
            imageId: "",
            isExBurst: false,
            isLB: false,
            isMultiPlayable: false,
            isSpecial: false,
            jobs: [],
            normalizedEffectText: "",
            name: "Unknown Card",
            number: 0,
            opus: 0,
            power: 0,
            rarity: "",
            serial: "",
            text: "",
            type: "",
            elements: [],
        },
        cardNumber: 0,
        finish: "base",
        fullSerial: "",
        id: "",
        imageId: "",
        isPrimaryVariant: false,
        isTempImage: false,
        octgnId: "",
        opus: 0,
        serial: "",
        products: [],
        tcgPlayerId: 0,
        variant: "Non-Foil",
        variantId: productDetailsCardJson.variantId,
        quantity: productDetailsCardJson.quantity
    }
}

export type ProductDetails = {
    id: number,
    name: string,
    imageSrc: string,
    description: string[],
    purchaseLinks: PurchaseLink[],
    productsDescription: string,
    products: ProductDetailsProduct[],
    cardsDescription: string,
    cards: ProductDetailsCard[]
}

export type SortType = "Release Date (Asc)" | "Release Date (Desc)" | "Name (Asc)" | "Name (Desc)";

export function getSortByOptions(): ComboBoxOption<SortType>[] {
    return [
        { label: "Release Date (Asc)", value: "Release Date (Asc)" },
        { label: "Release Date (Desc)", value: "Release Date (Desc)" },
        { label: "Name (Asc)", value: "Name (Asc)" },
        { label: "Name (Desc)", value: "Name (Desc)" }
    ];
}

export const DEFAULT_PRODUCT_SORT_OPTION = getSortByOptions().find(x => x.value === "Release Date (Desc)")!;